import { render, staticRenderFns } from "./formAuthorize.vue?vue&type=template&id=2806c0be&scoped=true&"
import script from "./formAuthorize.vue?vue&type=script&lang=js&"
export * from "./formAuthorize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2806c0be",
  null
  
)

export default component.exports